export default class SecToTime {
    [x: string]: any;
 	 static $inject = ['moment'];
    constructor(moment) {
        this.moment = moment;
    }

    parseTime(sec) {
        let momentTime = this.moment.duration(sec, 'seconds');
        let hours = (momentTime.hours() === 0) ? '' : this.formatTimePart(momentTime.hours()) + 'h ';
        return hours + this.formatTimePart(momentTime.minutes()) + 'm ' + this.formatTimePart(momentTime.seconds()) + 's';
    }

    formatTimePart(value) {
        return ('0' + value).slice(-2);
    }

}
